import React from "react";

const skillsData = [
  {
    category: "Programming Languages",
    skills: ["Java", "Python", "C++", "C#", "JavaScript", "XML", "C"]
  },
  {
    category: "Mobile & Game Development",
    skills: [
      "Android Development",
      "Unity Game Engine",
      "Firebase SDK",
      "Volley",
      "Picasso",
      "ExoPlayer"
    ]
  },
  {
    category: "Web & API Technologies",
    skills: [
      "REST APIs",
      "OpenStreetMaps API",
      "ImageBB API",
      "Google TTS",
      "Google One Tap Sign In"
    ]
  },
  {
    category: "Database & Cloud Services",
    skills: [
      "Firebase",
      "Firestore",
      "Firebase Authentication",
      "Firebase Realtime Database",
      "Cloud Messaging"
    ]
  },
  {
    category: "Development Tools",
    skills: [
      "Android Studio",
      "VS Code",
      "Visual Studio",
      "IntelliJ IDEA",
      "Unity",
      "Git/GitHub"
    ]
  },
  {
    category: "Engineering & Analysis",
    skills: [
      "AutoCAD",
      "MS Excel",
      "Process Optimization",
      "Material Analysis",
      "UI/UX Design"
    ]
  }
];

function Skills() {
  return (
    <section id="skills">
      <div className="container">
        <h2 className="section-title">Technical Skills</h2>
        <div className="skills-grid">
          {skillsData.map(({ category, skills }, idx) => (
            <div key={idx} className="skill-category">
              <h4>{category}</h4>
              <div className="skill-tags">
                {skills.map((skill, index) => (
                  <span key={index} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
